var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar-label d-flex align-items-center"
  }, [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "sidebar-label__icon d-flex justify-content-center align-items-center",
    attrs: {
      "title": _vm.title
    }
  }, [_c('ez-icon', {
    attrs: {
      "icon": _vm.icon,
      "size": "14"
    }
  })], 1), _c('span', {
    staticClass: "sidebar-label__text"
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }